/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerformata43Inputs */

const en_checkinflyerformata43 = /** @type {(inputs: Checkinflyerformata43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

const de_checkinflyerformata43 = /** @type {(inputs: Checkinflyerformata43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

/**
* | output |
* | --- |
* | "A4" |
*
* @param {Checkinflyerformata43Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerformata43 = /** @type {((inputs?: Checkinflyerformata43Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerformata43Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerformata43(inputs)
	return de_checkinflyerformata43(inputs)
});
export { checkinflyerformata43 as "checkinFlyerFormatA4" }